/**
 * Indian financial year helpers for Compliance UI.
 * Canonical label: YYYY-YY (e.g. 2026-27).
 */

export function fyLabel(date = new Date()) {
  const y = date.getFullYear();
  const m = date.getMonth() + 1;
  const startYear = m >= 4 ? y : y - 1;
  const endSuffix = String((startYear + 1) % 100).padStart(2, '0');
  return `${startYear}-${endSuffix}`;
}

export function currentFy() {
  return fyLabel(new Date());
}

export function recentFys(count = 3, ref = new Date()) {
  const labels = [];
  let cur = fyLabel(ref);
  for (let i = 0; i < count; i += 1) {
    labels.push(cur);
    const startYear = parseInt(cur.split('-')[0], 10);
    const prevRef = new Date(startYear - 1, 5, 1);
    cur = fyLabel(prevRef);
  }
  return labels;
}

export const PERIOD_OPTIONS = [
  { value: 'mtd', label: 'MTD' },
  { value: 'fy', label: 'FY' },
  { value: 'all', label: 'All' },
];
